// Carry Roll ValidationErrors — renders ValidationWarning[] inline (11.7).
// Consolidated into a single concise summary line by default, with the full
// list of caveats available on-demand (progressive disclosure). Collapsing the
// stack of simultaneous caution labels keeps the result dominant; the per-field
// detail expands when the user wants it. The native <details> element keeps the
// detail text in the DOM (so aria-live announcements + textContent still work).

import { useValidation } from '../../store/selectors';

export function ValidationErrors() {
  const warnings = useValidation().filter((w) => w.code !== 'info');
  if (warnings.length === 0) return null;
  const count = warnings.length;
  return (
    <details
      data-testid="validation-errors"
      aria-live="polite"
      className="panel"
      style={{ borderColor: 'var(--color-warn)', padding: 'var(--space-3)' }}
    >
      <summary
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-2)',
          color: 'var(--color-warn)',
          fontWeight: 'var(--fw-medium)',
          fontSize: 'var(--fs-sm)',
        }}
      >
        {count} input{count === 1 ? '' : 's'} to check
      </summary>
      <ul className="mt-2 list-disc pl-5">
        {warnings.map((w, i) => (
          <li key={`${w.field}-${i}`} className="text-sm">
            {w.message}
          </li>
        ))}
      </ul>
    </details>
  );
}
